import * as React from "react"

// Simple tag icon (FontAwesome-like silhouette) used in Tiptap floating menu.
export const TagIcon = React.memo(
  ({ className, ...props }: React.SVGProps<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3H4a1 1 0 0 0-1 1v5.59A2 2 0 0 0 3.83 11l9.58 9.59a2 2 0 0 0 2.83 0l4.35-4.35a2 2 0 0 0 0-2.83ZM6.5 7.5A1 1 0 1 1 7.5 6.5 1 1 0 0 1 6.5 7.5Z" />
      </svg>
    )
  }
)

TagIcon.displayName = "TagIcon"

